import React from "react";

export default function Content() {
  return (
    <div className="contents" id="desmosContent">
      <h2>How to Use Desmos Graphing Calculator</h2>
      <iframe 
        width="50%" 
        height="50%" 
        src="https://www.youtube.com/embed/RKbZ3RoA-x4" 
        title="YouTube video player" 
        frameBorder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowFullScreen>
      </iframe>
    </div>
  );
}
